import React, { useState } from 'react';

function shortCompanyName(fullName) {
  if (!fullName) return '';

  if (fullName.trim().length <= 8) {
    return fullName.trim();
  }
  
  const quotesPattern = /["«»„“”“‘’'](.*?)["«»„“”“‘’']/;
  const match = fullName.match(quotesPattern);
  
  if (match && match[1]) {
    const quoted = match[1];
    if (quoted.length > 8) {
      return quoted.substring(0, 8) + '...';
    }
    return quoted;
  }
  
  const legalForms = [
    'Товарищество с ограниченной ответственностью',
    'Акционерное общество',
    'Индивидуальный предприниматель',
    'Общество с ограниченной ответственностью',
    'ТОО',
    'АО',
    'ИП',
    'ООО'
  ];
  
  let result = fullName;
  for (const form of legalForms) {
    const regex = new RegExp(`^${form}\\s+`, 'i');
    result = result.replace(regex, '');
  }
  
  result = result.trim();
  if (result.length > 8) {
    return result.substring(0, 8) + '...';
  }
  
  return result;
}

function initUserName(fullName) {
  if (!fullName) return '';

  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 0) return '';

  let lastName = parts[0];
  if (lastName.length > 15) {
    lastName = lastName.slice(0, 15) + '...';
  }

  const initials = parts.slice(1).map(word => word[0] + '.').join('');

  return lastName + (initials ? '.' + initials : '');
}

export { shortCompanyName, initUserName };
